import { render, staticRenderFns } from "./Libra.vue?vue&type=template&id=64be2d13&lang=pug"
import script from "./Libra.vue?vue&type=script&lang=js"
export * from "./Libra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports